// DataContext.js
import React, { createContext, useState } from "react";

// Create the context
export const DataContext = createContext();

// Create a provider component
export const DataProvider = ({ children }) => {
  const [keyword, setKeyword] = useState("");
  const [searchStart, setSearchStart] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);
  const [reportModalDefaults, setReportModalDefaults] = useState(null);

  const value = {
    keyword,
    setKeyword,
    searchStart,
    setSearchStart,
    showReportModal,
    setShowReportModal,
    reportModalDefaults,
    setReportModalDefaults,
  };

  return <DataContext.Provider value={value}>{children}</DataContext.Provider>;
};
